import { api } from './apiProvider';

export const QuoteStatus = {
  Sent: 'Sent',
  Approved: 'Approved',
  Rejected: 'Rejected',
  Expired: 'Expired',
};

export interface QuoteListItem {
  id: string;
  total: number;
  depositTotal: number;
  quoteNumber: number;
  expirationDate: Date;
  status: string;
}

export async function listQuotes(): Promise<QuoteListItem[]> {
  return await api
    .get('Quotes', {
      credentials: 'include',
    })
    .json<QuoteListItem[]>();
}
